import { render, staticRenderFns } from "./exhibition-home-project.vue?vue&type=template&id=4f1f1408&scoped=true&"
import script from "./exhibition-home-project.vue?vue&type=script&lang=js&"
export * from "./exhibition-home-project.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-home-project.vue?vue&type=style&index=0&id=4f1f1408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f1408",
  null
  
)

export default component.exports